import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { SupplierResource } from "@exonn/js-sdk";
import { SupplierArticles } from "src/admin/modules/supplier/forms/supplier/tabs/articles/SupplierArticles.tsx";
import { SupplierConditions } from "src/admin/modules/supplier/forms/supplier/tabs/conditions/SupplierConditions.tsx";
import { SupplierCredits } from "src/admin/modules/supplier/forms/supplier/tabs/credits/SupplierCredits.tsx";

export const module: ModuleOptions<SupplierResource> = {
  resource: ResourceEnum.Supplier,
  // Вкладки (Lieferkonditionen, Artikel, Abrechnung) читают данные поставщика из контекста формы.
  layoutForm: true,
  bigIcon: <i className="icon-20-suppliers" />,
  smallIcon: <i className="icon-15-suppliers" />,

  tabs: {
    edit: {
      titleProp: "number",
    },
  },

  // «Aufträge» (заказы поставщику) добавится в фазе 2.
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    conditions: {
      title: (t) => t("formTabs.conditions.title"),
      routeObject: {
        Component: SupplierConditions,
      },
      isHidden: ({ data }) => !data?.id,
    },
    articles: {
      title: (t) => t("formTabs.articles.title"),
      routeObject: {
        Component: SupplierArticles,
      },
      isHidden: ({ data }) => !data?.id,
    },
    credits: {
      title: (t) => t("formTabs.credits.title"),
      routeObject: {
        Component: SupplierCredits,
      },
      isHidden: ({ data }) => !data?.id,
    },
  },
};
